import { render, staticRenderFns } from "./MedicationPrescriptionInput.vue?vue&type=template&id=e4c75c98&scoped=true"
import script from "./MedicationPrescriptionInput.vue?vue&type=script&lang=js"
export * from "./MedicationPrescriptionInput.vue?vue&type=script&lang=js"
import style0 from "./MedicationPrescriptionInput.vue?vue&type=style&index=0&id=e4c75c98&prod&lang=scss&scoped=true"
import style1 from "./MedicationPrescriptionInput.vue?vue&type=style&index=1&id=e4c75c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c75c98",
  null
  
)

export default component.exports